var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24213",
    "data-name": "Path 24213",
    d: "M0-682.665H35v35H0Z",
    transform: "translate(0 682.665)",
    fill: "#309afc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20599",
    "data-name": "Group 20599",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24194",
    "data-name": "Path 24194",
    d: "M-282.474-587.554h-15.265v-25.427a1.659,1.659,0,0,1,1.131-1.573l14.134-4.751Z",
    transform: "translate(302.372 621.255)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24195",
    "data-name": "Path 24195",
    d: "M-158.982-259.762v3.19h-8.591V-273.8h9.479a1.136,1.136,0,0,1,1.137,1.137v9.119",
    transform: "translate(187.47 290.274)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24196",
    "data-name": "Path 24196",
    d: "M0-59.021H13.819a.771.771,0,0,0,.771-.771v-2.419H0Z",
    transform: "translate(19.897 92.723)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24197",
    "data-name": "Path 24197",
    d: "M-52.823,0h.289a2.855,2.855,0,0,1,2.855,2.855V3.905h-6V2.855A2.855,2.855,0,0,1-52.823,0Z",
    transform: "translate(84.166 26.607)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24198",
    "data-name": "Path 24198",
    d: "M-14.264-59.021h3.349v-3.19h-4.12v2.419A.771.771,0,0,0-14.264-59.021Z",
    transform: "translate(15.547 92.723)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24199",
    "data-name": "Path 24199",
    d: "M-68.776,0h.4V3.905h-4.12V3.717A3.717,3.717,0,0,1-68.776,0Z",
    transform: "translate(73.006 26.607)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24200",
    "data-name": "Path 24200",
    d: "M-98.228-268.763h-5.308v-14.524l4.8,4.642a1.66,1.66,0,0,1,.506,1.193v6.272",
    transform: "translate(123.433 285.238)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24201",
    "data-name": "Path 24201",
    d: "M0-83.792v-3.462A1.066,1.066,0,0,1,1.066-88.32h.108A1.066,1.066,0,0,1,2.24-87.254v2.709",
    transform: "translate(8.367 89.618)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24202",
    "data-name": "Path 24202",
    d: "M-213.375,0l-11.531,3.876",
    transform: "translate(233.273 5.826)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24203",
    "data-name": "Path 24203",
    d: "M-213.375,0l-11.531,3.876",
    transform: "translate(233.273 9.516)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24204",
    "data-name": "Path 24204",
    d: "M-213.375,0l-11.531,3.876",
    transform: "translate(233.273 13.206)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24205",
    "data-name": "Path 24205",
    d: "M-213.375,0l-11.531,3.876",
    transform: "translate(233.273 16.896)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24206",
    "data-name": "Path 24206",
    d: "M-35.224,0l-1.9.64",
    transform: "translate(45.494 23.822)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24207",
    "data-name": "Path 24207",
    d: "M-135.664,0-143,2.464",
    transform: "translate(155.562 20.586)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24208",
    "data-name": "Path 24208",
    d: "M-112.438-119.074h-6.076v-4.356a.752.752,0,0,1,.55-.725l4.772-1.332a.594.594,0,0,1,.754.572Z",
    transform: "translate(126.881 152.776)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24209",
    "data-name": "Path 24209",
    d: "M-99.552-35.862h-5.028a.352.352,0,0,1-.352-.352v-1.234a.352.352,0,0,1,.352-.352h5.028a.352.352,0,0,1,.352.352v1.234A.352.352,0,0,1-99.552-35.862Z",
    transform: "translate(127.235 56.565)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24210",
    "data-name": "Path 24210",
    d: "M-99.552-35.862h-5.028a.352.352,0,0,1-.352-.352v-1.234a.352.352,0,0,1,.352-.352h5.028a.352.352,0,0,1,.352.352v1.234A.352.352,0,0,1-99.552-35.862Z",
    transform: "translate(127.235 60.464)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24211",
    "data-name": "Path 24211",
    d: "M-37.286-35.862h-1.663a.352.352,0,0,1-.352-.352v-1.234a.352.352,0,0,1,.352-.352h1.663a.352.352,0,0,1,.352.352v1.234A.352.352,0,0,1-37.286-35.862Z",
    transform: "translate(61.605 64.402)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24212",
    "data-name": "Path 24212",
    d: "M0,0V5.775",
    transform: "translate(11.405 27.927)",
    fill: "none",
    stroke: "#309afc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCompany);
export default __webpack_public_path__ + "static/media/allCompany.6f971f953f2fcdf8ce43ecc5db230527.svg";
export { ForwardRef as ReactComponent };